import React, { useState } from 'react';

// Hooks
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { success, failure } from '../../../../redux/actions/snackbar-actions';
import { regeneratePDF, fetchAdminBatches } from '../../../../redux/actions/admin-batch-actions';

// Utils
import { MESSAGES } from '../../../../utils/message';
import ConfirmModal from '~/components/General/ConfirmModal';

const RegeneratePDFModal = (props) => {
  const { openModal, handleCloseModal, batchId, searchApplied, pagination } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const applyFilters = useSelector((state) => state.adminBatchesReducers.applyFilters);
  const filters = useSelector((state) => state.adminBatchesReducers.filters);

  const onSubmit = async () => {
    try {
      setLoading(true);
      const response = await dispatch(regeneratePDF(batchId));
      if (response.status === 200) {
        dispatch(success(response?.data?.message));
        dispatch(
          fetchAdminBatches({
            ...(searchApplied ? { search: batchId } : {}),
            pagination: { ...pagination },
            applyFilters,
            filters: applyFilters ? filters : null,
          })
        );
        handleCloseModal();
      } else {
        dispatch(failure(response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message));
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  return (
    <ConfirmModal
      openConfirmModal={{
        open: openModal,
        header: MESSAGES.ADMIN_DASHBOARD.BATCHES.REGENERATE_PDF.TITLE,
        message: MESSAGES.ADMIN_DASHBOARD.BATCHES.REGENERATE_PDF.HEADING,
        handleOk: onSubmit,
        handleClose: handleCloseModal,
        loading,
        successButtonName: MESSAGES.ADMIN_DASHBOARD.BATCHES.REGENERATE_PDF.SUBMIT_BUTTON,
        cancelButtonName: MESSAGES.ADMIN_DASHBOARD.BATCHES.REGENERATE_PDF.CANCEL_BUTTON,
        compactActions: true,
      }}
    />
  );
};

export default RegeneratePDFModal;
